import { render, staticRenderFns } from "./spei-payment.vue?vue&type=template&id=9eb0f1e6&scoped=true&"
import script from "./spei-payment.vue?vue&type=script&lang=js&"
export * from "./spei-payment.vue?vue&type=script&lang=js&"
import style0 from "./spei-payment.vue?vue&type=style&index=0&id=9eb0f1e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb0f1e6",
  null
  
)

export default component.exports